import * as PIXI from 'pixi.js';
//import { getFont } from '../Utilities/fonts';

function Load(currentPlaybackStateObj, subscene, index) {
  var text = subscene.text_lines[index].text;
  text = text + ' ';
  let textLineContainer = new PIXI.Container();
  let textPartsArray = [];
  textLineContainer.sortableChildren = true;
  if (text) {
    text = text.replaceAll('<strong></strong>', '');
    let captionStyle = getTextStyle(currentPlaybackStateObj, subscene);
    let highlightStyle = getTextStyle(currentPlaybackStateObj, subscene, true);
    subscene.captionStyle = captionStyle;
    subscene.highlightStyle = highlightStyle;
    splitText(text, currentPlaybackStateObj, subscene, textLineContainer, 0, textPartsArray);
    var x1 = 0;
    var xAdd = 0.8 * currentPlaybackStateObj.currentScaleX;
    let prevWidth = 0;
    let empty = new PIXI.Text(' ');
    empty.cacheAsBitmap = true;
    textLineContainer.addChild(empty);
    for (var k in textPartsArray) {
      if (k == 0) {
        textPartsArray[k].x = 0;
        prevWidth = textPartsArray[k].width;
        textLineContainer.addChild(textPartsArray[k]);
        continue;
      }
      x1 += prevWidth - xAdd;
      textPartsArray[k].x = x1;
      textLineContainer.addChild(textPartsArray[k]);
      prevWidth = textPartsArray[k].width;
    }
    //console.log(textPartsArray);
  } else {
    var textLine = subscene.text_lines[index];
    if (textLine.stroke_color && textLine.stroke_width) {
      var StrokeGraphic = GenerateStrokeGraphic(
        textLine.stroke_color,
        textLine.stroke_width * currentPlaybackStateObj.currentScaleX,
        0.4 * subscene.font.line_height * currentPlaybackStateObj.currentScaleY
      );
      StrokeGraphic.zIndex = 2;
      textLineContainer.addChild(StrokeGraphic);
    }
  }
  if (
    subscene.font.decoration &&
    (subscene.font.decoration === 'decor-linethrough' || subscene.font.decoration.includes('decor-linethrough'))
  ) {
    var lineThrough = GenerateStrokeGraphic(
      subscene.font.color,
      textLineContainer.width - parseFloat(subscene.font.size) * 1.33 * currentPlaybackStateObj.currentScaleY * 0.75,
      0.06 *
      (subscene.font.line_height
        ? subscene.font.line_height * currentPlaybackStateObj.currentScaleY
        : parseFloat(subscene.font.size) * 1.33 * currentPlaybackStateObj.currentScaleY * 1.3)
    );
    lineThrough.y =
      textLineContainer.y +
      textLineContainer.height / 2 -
      parseFloat(subscene.font.size) * 1.33 * currentPlaybackStateObj.currentScaleY * 0.25;
    lineThrough.zIndex = 4;
    textLineContainer.addChild(lineThrough);
  }
  if (
    subscene.font.decoration &&
    (subscene.font.decoration === 'decor-underline' || subscene.font.decoration.includes('decor-underline'))
  ) {
    var lineThrough = GenerateStrokeGraphic(
      subscene.font.color,
      textLineContainer.width - parseFloat(subscene.font.size) * 1.33 * currentPlaybackStateObj.currentScaleY * 0.75,
      0.06 *
      (subscene.font.line_height
        ? subscene.font.line_height * currentPlaybackStateObj.currentScaleY
        : parseFloat(subscene.font.size) * 1.33 * currentPlaybackStateObj.currentScaleY * 1.3)
    );
    lineThrough.y =
      textLineContainer.y +
      textLineContainer.height -
      0.16 * textLineContainer.height -
      parseFloat(subscene.font.size) * 1.33 * currentPlaybackStateObj.currentScaleY * 0.35;
    lineThrough.zIndex = 1;
    textLineContainer.addChild(lineThrough);
  }
  return { textLineContainer, textPartsArray };
}

function getTextStyle(currentPlaybackStateObj, subscene, isKeyword) {
  var style = new PIXI.TextStyle();
  style.fontSize = parseFloat(parseFloat(subscene.font.size) * 1.33).toFixed(1) + 'px';
  if (subscene.font.name) {
    var fontName = subscene.font.name;
    if (fontName.includes('.ttf')) {
      fontName = fontName.replace('.ttf', '');
    }
    var fontDetails = getFontfamily(fontName, subscene.font.decoration);
    if (fontDetails.fontFamily) {
      style.fontFamily = fontDetails.fontFamily;
    }
    if (fontDetails.fontWeight) {
      style.fontWeight = fontDetails.fontWeight;
    }
  }
  if (subscene.font.textShadowColor && subscene.font.textShadowWidthFr) {
    style.dropShadow = true;
    style.dropShadowAngle = 0;
    style.dropShadowColor = convertRGBAStringToHex(subscene.font.textShadowColor);
    style.dropShadowAlpha = getTextShadowAlpha(subscene.font.textShadowColor);
    //textItem.style.dropShadowBlur = Math.ceil( Math.ceil(parseFloat(subscene.font.size)*1.33) * currentPlaybackStateObj.currentScaleY) * subscene.font.textShadowWidthFr ;
    style.dropShadowBlur = subscene.font.size * 2 * subscene.font.textShadowWidthFr; // * currentPlaybackStateObj.currentScaleY;
    style.dropShadowDistance = 0;
  }
  //style.lineHeight = parseFloat(subscene.font.size) * 1.33 * 1.2; // * currentPlaybackStateObj.currentScaleY;
  style.fill = subscene.font.color;
  if (isKeyword) {
    style.fill = subscene.font.keycolor;
  }
  style.padding = parseFloat(subscene.font.size) * 1.33 * 0.25;
  // if (subscene.font.name === 'JMModern.ttf') {
  //   textItem.style.padding = parseFloat(subscene.font.size) * 0.8 * 0.12;
  // }
  return style;
}

function splitText(text, currentPlaybackStateObj, subscene, textLineContainer, width, textPartsArray) {
  if (text) {
    var strongStartIndex = text.indexOf('<strong>');
    if (strongStartIndex !== -1) {
      var firstPart = text.substr(0, strongStartIndex);
      //format and add first part
      if (firstPart != '') {
        var firstPartElement = formatText(
          currentPlaybackStateObj,
          firstPart,
          subscene,
          false,
          textLineContainer,
          textPartsArray
        );
      }
      var strongEndIndex = text.indexOf('</strong>');
      var strongPart = text.substr(strongStartIndex + 8, strongEndIndex - (strongStartIndex + 8));
      if (strongPart.indexOf('<strong>') !== -1) {
        let strongPartText = text.substr(strongStartIndex + 8, text.length);
        let strongPartinnerEndIndex = strongPartText.indexOf('</strong>');
        let rem =
          strongPartText.substr(0, strongPartinnerEndIndex).replace('<strong>', '') +
          strongPartText.substr(strongPartinnerEndIndex + 9, strongPartText.length);
        strongEndIndex = rem.indexOf('</strong>') + 25;
        strongPart = text
          .substr(strongStartIndex + 8, strongEndIndex - 8)
          .replace('<strong>', '')
          .replace('</strong>', '');
        strongEndIndex = strongEndIndex + strongStartIndex;
      }
      var remainingText = text.substr(strongEndIndex + 9, text.length);
      if (remainingText && remainingText.length > 0 && remainingText != '' && remainingText.startsWith(' ')) {
        if (!strongPart.endsWith(' ')) {
          strongPart = strongPart + ' ';
        }
        remainingText = text.substr(strongEndIndex + 10, text.length);
      }
      var strongPartElement = formatText(
        currentPlaybackStateObj,
        strongPart,
        subscene,
        true,
        textLineContainer,
        textPartsArray
      );
      let firstPartElementWidth = 0;
      if (firstPartElement && firstPartElement.width) {
        firstPartElementWidth = firstPartElement.width;
      }
      splitText(
        remainingText,
        currentPlaybackStateObj,
        subscene,
        textLineContainer,
        width + firstPartElementWidth + strongPartElement.width,
        textPartsArray
      );
    } else {
      var firstPart = text;
      //format and add first part
      var firstPartElement = formatText(
        currentPlaybackStateObj,
        firstPart.endsWith(' ') ? firstPart : firstPart + ' ',
        subscene,
        false,
        textLineContainer,
        textPartsArray
      );
    }
  }
}

function removeHTML(str) {
  var tmp = document.createElement('DIV');
  tmp.innerHTML = str;
  return tmp.textContent || tmp.innerText || '';
}

function formatText(currentPlaybackStateObj, text, subscene, isKeyword, textLineContainer, textPartsArray) {
  text = removeHTML(text);
  let partitionLevel =
    subscene?.text_lines?.[0]?.text_animation?.filter(x => x.type == 'entry')?.[0]?.writingStyle ||
    subscene?.text_lines?.[0]?.text_animation?.filter(x => x.type == 'exit')?.[0]?.writingStyle ||
    'line';
  let textParts = [];
  if (partitionLevel == 'line' || partitionLevel == 'paragraph') {
    textParts = [text];
  } else if (partitionLevel == 'word') {
    textParts = text.split(' ');
    let result = [];
    for (let i = 0; i < textParts.length; i++) {
      result.push(textParts[i]);
      if (i !== textParts.length - 1) {
        result.push(' '); // Add space except after the last word
      }
    }
    textParts = result;
  } else if (partitionLevel == 'character') {
    textParts = text.split('');
  }
  for (var k in textParts) {
    let textItem = new PIXI.Text(textParts[k]);
    textItem.style = subscene.captionStyle;
    if (isKeyword) {
      textItem.style = subscene.highlightStyle;
    }
    textItem = setDecorations(subscene.font.decoration, textItem);
    textItem = setCase(subscene.font.case, textItem);
    textItem.resolution = 1.5;
    //textItem.roundPixels = true;
    if (currentPlaybackStateObj.isTemplateGridPreview) {
      textItem.resolution = 3;
    }

    if (currentPlaybackStateObj.isTemplateGridPreview) {
      textItem.style.padding = parseFloat(subscene.font.size) * 1.33 * 0.12;
    }
    textItem.scale.set(currentPlaybackStateObj.currentScaleX, currentPlaybackStateObj.currentScaleY);
    textItem.zIndex = 1;
    textPartsArray.push(textItem);
  }

  return textPartsArray;
}

function getTextShadowAlpha(color) {
  let alpha = 1;
  if (color.includes('rgba')) {
    var colorArray = color.replace('rgba(', '').replace(')', '').split(',');
    alpha = parseFloat(colorArray[3]);
  }
  return alpha;
}
function convertRGBAStringToHex(color) {
  if (color.includes('rgba')) {
    var colorArray = color.replace('rgba(', '').replace(')', '').split(',');
    var alphaVal = parseInt(colorArray[3]) / 255;
  } else {
    var colorArray = color.replace('rgb(', '').replace(')', '').split(',');
  }
  var col = ConvertRGBtoHex(parseInt(colorArray[0]), parseInt(colorArray[1]), parseInt(colorArray[2]));
  return col;
}

function setDecorations(decor, textItem) {
  if (decor && (decor === 'decor-bold' || decor.includes('decor-bold'))) {
    textItem.style.fontWeight = 'bold';
  }
  if (decor && (decor === 'decor-italics' || decor.includes('decor-italics'))) {
    textItem.style.fontStyle = 'italic';
    //textItem.style.padding = 2;
  }
  // else if(decor==='decor-underline'){

  // }
  // else if(decor==='decor-linethrough'){
  //     //textItem.style.strokeThickness = 2;
  // }
  //textItem.updateText();
  return textItem;
}

function setCase(caseValue, textItem) {
  if (caseValue === 'case-uppercase') {
    textItem.text = textItem.text.toUpperCase();
  } else if (caseValue === 'case-lowercase') {
    textItem.text = textItem.text.toLowerCase();
  } else if (caseValue === 'case-capitalize') {
    textItem.text = capitalizeFirstLetter(textItem.text);
  } else if (caseValue === 'case-smallcapitalize') {
    textItem.style.fontVariant = 'small-caps';
  }
  //textItem.updateText();
  return textItem;
}

function capitalizeFirstLetter(str) {
  // converting first letter to uppercase
  const arr = str.split(' ');
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  const capitalized = arr.join(' ');
  return capitalized;
}

function getFontfamily(fontName, decoration) {
  var result = {};
  if (fontName === 'Arial-Bold') {
    result.fontFamily = 'Arial';
    result.fontWeight = 'bold';
  } else if (fontName === 'Arial') {
    result.fontFamily = 'Arial';
  } else if (fontName === 'Calibri-Bold') {
    result.fontFamily = 'Calibri';
    result.fontWeight = 'bold';
  } else if (fontName === 'Calibri') {
    result.fontFamily = 'Calibri';
  } else if (fontName === 'Helvetica') {
    result.fontFamily = 'Helvetica';
    result.fontWeight = 'normal';
  } else if (fontName === 'Helvetica-Regular') {
    result.fontFamily = 'Helvetica';
    result.fontWeight = 'normal';
  } else if (fontName === 'HelveticaNeue-Medium') {
    result.fontFamily = 'Helvetica Neue';
    result.fontWeight = 'bold';
  } else if (fontName === 'Lato-Bold') {
    result.fontFamily = 'Lato';
    result.fontWeight = 'bold';
  } else if (fontName === 'Lato-Black') {
    result.fontFamily = 'Lato';
    result.fontWeight = '900';
  } else if (fontName === 'Merriweather-Bold') {
    result.fontFamily = 'Merriweather';
    result.fontWeight = 'bold';
  } else if (fontName === 'Montserrat-Bold') {
    result.fontFamily = 'Montserrat';
    result.fontWeight = 'bold';
  } else if (fontName === 'Montserrat-ExtraBold') {
    result.fontFamily = 'Montserrat';
    result.fontWeight = '900';
  } else if (fontName === 'NotoSans') {
    result.fontFamily = 'Noto Sans';
  } else if (fontName === 'NotoSans-Bold') {
    result.fontFamily = 'Noto Sans';
    result.fontWeight = 'bold';
  } else if (fontName === 'NotoSansJP') {
    result.fontFamily = 'Noto Sans JP';
  } else if (fontName === 'NotoSansJP-Bold') {
    result.fontFamily = 'Noto Sans JP';
    result.fontWeight = 'bold';
  } else if (fontName === 'NotoSerifJP') {
    result.fontFamily = 'Noto Serif JP';
  } else if (fontName === 'NotoSerifJP-Bold') {
    result.fontFamily = 'Noto Serif JP';
    result.fontWeight = 'bold';
  }
  else if (fontName === 'OpenSans') {
    result.fontFamily = 'Open Sans';
  } else if (fontName === 'OpenSans-Bold') {
    result.fontFamily = 'Open Sans';
    result.fontWeight = 'bold';
  } else if (fontName === 'Poppins-Bold') {
    result.fontFamily = 'Poppins';
    result.fontWeight = 'bold';
  } else if (fontName === 'Poppins-ExtraBold') {
    result.fontFamily = 'Poppins';
    result.fontWeight = '900';
  } else if (fontName === 'Quicksand') {
    result.fontFamily = 'Quicksand';
  } else if (fontName === 'Quicksand-Bold') {
    result.fontFamily = 'Quicksand';
    result.fontWeight = 'bold';
  } else if (fontName === 'Roboto') {
    result.fontFamily = 'Roboto';
  } else if (fontName === 'Roboto-Bold') {
    result.fontFamily = 'Roboto';
    result.fontWeight = 'bold';
  } else if (fontName === 'Rokkitt') {
    result.fontFamily = 'Rokkitt';
  } else if (fontName === 'Rokkitt-Bold') {
    result.fontFamily = 'Rokkitt';
    result.fontWeight = 'bold';
  } else if (fontName === 'SourceSansPro') {
    result.fontFamily = 'Source Sans Pro';
  } else if (fontName === 'SourceSansPro-Bold') {
    result.fontFamily = 'Source Sans Pro';
    result.fontWeight = 'bold';
  } else if (fontName === 'Ubuntu') {
    result.fontFamily = 'Ubuntu';
  } else if (fontName === 'Ubuntu-Bold') {
    result.fontFamily = 'Ubuntu';
    result.fontWeight = 'bold';
  } else if (fontName === 'ProximaNova') {
    result.fontFamily = 'ProximaNova';
    result.fontWeight = 'normal';
  } else if (fontName === 'Moondance') {
    result.fontFamily = 'Moon dance';
    result.fontWeight = 'normal';
  } else if (fontName === 'AveriaLibre') {
    result.fontFamily = 'Averia Libre';
    result.fontWeight = 'normal';
  } else if (fontName === 'CourierPrime') {
    result.fontFamily = 'Courier Prime';
    result.fontWeight = 'normal';
  } else if (fontName === 'Grandstander') {
    result.fontFamily = 'Grandstander';
    result.fontWeight = 'normal';
  } else if (fontName === 'JosefinSans') {
    result.fontFamily = 'Josefin Sans';
    result.fontWeight = 'normal';
  } else if (fontName === 'Spacemono') {
    result.fontFamily = 'Space mono';
    result.fontWeight = 'normal';
  } else if (fontName === 'Rowdies') {
    result.fontFamily = 'Rowdies';
    result.fontWeight = 'normal';
  } else if (fontName === 'DancingScript') {
    result.fontFamily = 'Dancing Script';
    result.fontWeight = 'normal';
  } else if (fontName === 'Caveat') {
    result.fontFamily = 'Caveat';
    result.fontWeight = 'normal';
  } else if (fontName === 'Lato') {
    result.fontFamily = 'Lato';
    result.fontWeight = 'normal';
  } else if (fontName === 'Merriweather') {
    result.fontFamily = 'Merriweather';
    result.fontWeight = 'normal';
  } else if (fontName === 'Poppins') {
    result.fontFamily = 'Poppins';
    result.fontWeight = 'normal';
  } else if (fontName === 'Montserrat') {
    result.fontFamily = 'Montserrat';
    result.fontWeight = 'normal';
  } else if (fontName === 'Chewy') {
    result.fontFamily = 'Chewy';
    result.fontWeight = 'normal';
  } else if (fontName === "Anton") {
    result.fontFamily = "Anton";
    result.fontWeight = "normal";
  } else if (fontName === "Barlow") {
    result.fontFamily = "Barlow";
    result.fontWeight = "normal";
  } else if (fontName === "BarlowBlack" || fontName === "Barlow Black") {
    result.fontFamily = "Barlow";
    result.fontWeight = "900";
  } else if (fontName === "BebasNeue") {
    result.fontFamily = "Bebas Neue";
    result.fontWeight = "normal";
  } else if (fontName === "Caprasimo") {
    result.fontFamily = "Caprasimo";
    result.fontWeight = "normal";
  } else if (fontName === "Capriola") {
    result.fontFamily = "Capriola";
    result.fontWeight = "normal";
  } else if (fontName === "CarterOne") {
    result.fontFamily = "Carter One";
    result.fontWeight = "normal";
  } else if (fontName === "ChakraPetch") {
    result.fontFamily = "Chakra Petch";
    result.fontWeight = "normal";
  } else if (fontName === "Chewy") {
    result.fontFamily = "Chewy";
    result.fontWeight = "normal";
  } else if (fontName === "Comfortaa") {
    result.fontFamily = "Comfortaa";
    result.fontWeight = "normal";
  } else if (fontName === "Dangrek") {
    result.fontFamily = "Dangrek";
    result.fontWeight = "normal";
  } else if (fontName === "DeliusUnicase") {
    result.fontFamily = "Delius Unicase";
  } else if (fontName === "Gruppo") {
    result.fontFamily = "Gruppo";
  } else if (fontName === 'JuliusSansOne' || fontName === 'Julius Sans One' || fontName === 'JuliusSans One') {
    result.fontFamily = "Julius Sans One";
    result.fontWeight = "normal";
  } else if (fontName === "PatuaOne") {
    result.fontFamily = "Patua One";
    result.fontWeight = "normal";
  } else if (fontName === "Raleway") {
    result.fontFamily = "Raleway";
    result.fontWeight = "normal";
  } else if (fontName === "Raleway Black" || fontName === "RalewayBlack") {
    result.fontFamily = "Raleway";
    result.fontWeight = "900";
  } else if (fontName === "Raleway Thin" || fontName === "RalewayThin") {
    result.fontFamily = "Raleway";
    result.fontWeight = "100";
  } else if (fontName === "RussoOne") {
    result.fontFamily = "Russo One";
    result.fontWeight = "normal";
  } else if (fontName === "Satisfy") {
    result.fontFamily = "Satisfy";
    result.fontWeight = "normal";
  } else if (fontName === "SpecialElite") {
    result.fontFamily = "Special Elite";
    result.fontWeight = "normal";
  } else if (fontName === "TitilliumWeb") {
    result.fontFamily = "Titillium Web";
    result.fontWeight = "normal";
  } else if (
    fontName === "TitilliumWebBlack" ||
    fontName === "TitilliumWeb Black"
  ) {
    result.fontFamily = "Titillium Web";
    result.fontWeight = "900";
  } else if (fontName === "Unbounded") {
    result.fontFamily = "Unbounded";
    result.fontWeight = "normal";
  } else if (fontName === "JMModern") {
    result.fontFamily = "JM Modern";
  } else if (fontName === "Heartbeat") {
    result.fontFamily = "Heartbeat";
  } else if (fontName === "Laisha") {
    result.fontFamily = "Laisha";
  } else if (fontName === "Strive") {
    result.fontFamily = "Strive";
  } else if (fontName === "PartyConfetti") {
    result.fontFamily = "Party Confetti";
  } else if (fontName === "ArchivoNarrow") {
    result.fontFamily = "Archivo Narrow";
    if (
      decoration?.includes("decor-bold") &&
      decoration?.includes("decor-italics")
    ) {
      result.fontFamily = result.fontFamily + "__BoldItalic";
    } else if (decoration?.includes("decor-bold")) {
      result.fontFamily = result.fontFamily + "__Bold";
    } else if (decoration?.includes("decor-italics")) {
      result.fontFamily = result.fontFamily + "__Italic";
    }
  } else if (fontName === "DMSans") {
    result.fontFamily = "DM Sans";
    if (
      decoration?.includes("decor-bold") &&
      decoration?.includes("decor-italics")
    ) {
      result.fontFamily = result.fontFamily + "__BoldItalic";
    } else if (decoration?.includes("decor-bold")) {
      result.fontFamily = result.fontFamily + "__Bold";
    } else if (decoration?.includes("decor-italics")) {
      result.fontFamily = result.fontFamily + "__Italic";
    }
  } else if (fontName === "WorkSans") {
    result.fontFamily = "Work Sans";
    if (
      decoration?.includes("decor-bold") &&
      decoration?.includes("decor-italics")
    ) {
      result.fontFamily = result.fontFamily + "__BoldItalic";
    } else if (decoration?.includes("decor-bold")) {
      result.fontFamily = result.fontFamily + "__Bold";
    } else if (decoration?.includes("decor-italics")) {
      result.fontFamily = result.fontFamily + "__Italic";
    }
  } else if (fontName === "LTWave") {
    result.fontFamily = "LT Wave";
    if (
      decoration?.includes("decor-bold") &&
      decoration?.includes("decor-italics")
    ) {
      result.fontFamily = result.fontFamily + "__BoldItalic";
    } else if (decoration?.includes("decor-bold")) {
      result.fontFamily = result.fontFamily + "__Bold";
    } else if (decoration?.includes("decor-italics")) {
      result.fontFamily = result.fontFamily + "__Italic";
    }
  } else if (fontName === "PlusJakarta Sans") {
    result.fontFamily = "Plus Jakarta Sans";
    if (
      decoration?.includes("decor-bold") &&
      decoration?.includes("decor-italics")
    ) {
      result.fontFamily = result.fontFamily + "__BoldItalic";
    } else if (decoration?.includes("decor-bold")) {
      result.fontFamily = result.fontFamily + "__Bold";
    } else if (decoration?.includes("decor-italics")) {
      result.fontFamily = result.fontFamily + "__Italic";
    }
  } else if (fontName === "Playfairdisplay") {
    result.fontFamily = "Playfairdisplay";
    if (
      decoration?.includes("decor-bold") &&
      decoration?.includes("decor-italics")
    ) {
      result.fontFamily = result.fontFamily + "__BoldItalic";
    } else if (decoration?.includes("decor-bold")) {
      result.fontFamily = result.fontFamily + "__Bold";
    } else if (decoration?.includes("decor-italics")) {
      result.fontFamily = result.fontFamily + "__Italic";
    }
  } else if (fontName === "Lexend") {
    result.fontFamily = "Lexend";
    if (decoration?.includes("decor-bold")) {
      result.fontFamily = result.fontFamily + "__Bold";
    }
  } else if (fontName === "Manrope") {
    result.fontFamily = "Manrope";
    if (decoration?.includes("decor-bold")) {
      result.fontFamily = result.fontFamily + "__Bold";
    }
  } else if (fontName === "Mustard") {
    result.fontFamily = "Mustard";
    if (decoration?.includes("decor-bold")) {
      result.fontFamily = result.fontFamily + "__Bold";
    }
  } else if (fontName === "Sora") {
    result.fontFamily = "Sora";
    if (decoration?.includes("decor-bold")) {
      result.fontFamily = result.fontFamily + "__Bold";
    }
  } else if (fontName === "Optik") {
    result.fontFamily = "Optik";
    if (decoration?.includes("decor-bold")) {
      result.fontFamily = result.fontFamily + "__Bold";
    }
  } else if (fontName === "SpaceGrotesk") {
    result.fontFamily = "Space Grotesk";
    if (decoration?.includes("decor-bold")) {
      result.fontFamily = result.fontFamily + "__Bold";
    }
  }
  else {
    result.fontFamily = fontName;
  }
  return result;
}

function GenerateStrokeGraphic(backcolor, width, height) {
  let backGround = new PIXI.Graphics();
  if (backcolor) {
    if (backcolor.includes('rgba')) {
      var colorArray = backcolor.replace('rgba(', '').replace(')', '').split(',');
    } else {
      var colorArray = backcolor.replace('rgb(', '').replace(')', '').split(',');
    }
    var col = ConvertRGBtoHex(parseInt(colorArray[0]), parseInt(colorArray[1]), parseInt(colorArray[2]));
    backGround.beginFill(PIXI.utils.string2hex(col), 1);
    backGround.drawRect(0, 0, width, height);
    backGround.endFill();
  }
  return backGround;
}
function ConvertRGBtoHex(red, green, blue) {
  return '#' + ColorToHex(red) + ColorToHex(green) + ColorToHex(blue);
}
function ColorToHex(color) {
  var hexadecimal = color.toString(16);
  return hexadecimal.length == 1 ? '0' + hexadecimal : hexadecimal;
}
function LoadText(currentPlaybackStateObj, subscene, index) {
  var text = subscene.text_lines[index].text;
  text = text + ' ';
  if (text) {
    let textObj = formatText(currentPlaybackStateObj, text, subscene, false);
    return textObj;
  }
}
export default { Load, LoadText };
